import { Box, Button, TextField, useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { cancelSellorBuy, customerReport, getCustomersInfo } from "../../api/financeapi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useMemo, useState } from "react";
import { Table, Modal } from "react-bootstrap";
import { AiFillCloseCircle } from "react-icons/ai";
import B from "react-bootstrap/Button";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
// import myImage from "../systelogo.png";
import myImage from "../logo2.jpeg";

const createCircularImage = (src, size = 400) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = size;
      canvas.height = size;
      const context = canvas.getContext("2d");

      context.clearRect(0, 0, size, size);
      context.save();
      context.beginPath();
      context.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
      context.closePath();
      context.clip();

      const scale = Math.max(size / image.width, size / image.height);
      const width = image.width * scale;
      const height = image.height * scale;
      const x = (size - width) / 2;
      const y = (size - height) / 2;
      context.drawImage(image, x, y, width, height);
      context.restore();

      resolve(canvas.toDataURL("image/png"));
    };
    image.onerror = reject;
    image.src = src;
  });

const Form = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const theme = useTheme();
  const showToastMessage = (type, message) => {
    toast(message, {
      type: type,
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };
  const [salesreportinformation, setSalesreportInformation] = useState([]);
  const [salesinfo, setSalesInfo] = useState({
    customer_id: "",
    fromDate: "",
    toDate: "",
  });
  const [customer_information, setCustomerInfo] = useState([]);
  const [show, setShow] = useState(false);
  const [deleteDate, setDeleteDate] = useState("");
  useEffect(() => {
    getcustomerinfo();
  }, []);
  const getcustomerinfo = async () => {
    var customerInfo = await getCustomersInfo();
    setCustomerInfo(customerInfo.Message);
  };
  const handleFormSubmit = async (event) => {
    document.getElementById("btnSubmit").innerText = "Loading...";

    setSalesreportInformation([]);
    event.preventDefault();
    var post = new FormData();
    post.append("action", "customerReport");
    post.append("CustomerID", salesinfo.customer_id);
    post.append("FromDate", salesinfo.fromDate);
    post.append("ToDate", salesinfo.toDate);
    var salesreportInfo = await customerReport(post);

    if (salesreportInfo.status) {
      if (salesreportInfo.Message.length === 0)
        showToastMessage("error", "No data Found.");

      setSalesreportInformation(salesreportInfo.Message);
      var regExpenseForm = document.getElementById("regExpenseForm");
      regExpenseForm.reset();
      setSalesInfo({
        customer_id: "",
        fromDate: "",
        toDate: "",
      });
    } else {
      setSalesreportInformation([]);

      showToastMessage("error", salesreportInfo.Message);
    }
    document.getElementById("btnSubmit").innerText = "Search";
  };

  const handleClickDelete = async (saleDate) => {
   setDeleteDate(saleDate);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleClickDeleteButton = async () => {
    var post = new FormData();
    post.append("action", "cancelSellorBuy");
    post.append("RegisterDate", deleteDate);
    post.append("type", "sell");
    var ExpenseInfo = await cancelSellorBuy(post);

    if (ExpenseInfo.status) {
      showToastMessage("success", ExpenseInfo.Message);
    } else {
      showToastMessage("error", ExpenseInfo.Message);
    }
    setSalesreportInformation([]);
    setDeleteDate("");
    setShow(false);
  };

  const handleOnChange = (event) => {
    const { name, value } = event.target;
    setSalesInfo({ ...salesinfo, [name]: value });
  };

  const pdfColumns = [
    { title: "#", field: "index" },
    { title: "Name", field: "customer_name" },
    { title: "Phone", field: "customer_phone" },
    { title: "Type", field: "record_type" },
    { title: "Data Source", field: "data_source" },
    { title: "Debt", field: "debt" },
    { title: "Pay", field: "pay" },
    { title: "Balance", field: "balance" },
    { title: "Description", field: "description" },
    { title: "Register By", field: "fname" },
    { title: "Date", field: "date" },
  ];

  const isReportPaymentRow = (sale) =>
    sale.record_type === "CustomerDebtPayment" ||
    (sale.data_source === "Old Data" && sale.record_type === "CustomerPay");

  const reportRowsWithSplits = useMemo(() => {
    return salesreportinformation.map((sale, index) => {
      const m = parseFloat(sale.money || 0);
      const isPay = isReportPaymentRow(sale);
      return {
        ...sale,
        index: index + 1,
        debt: isPay ? "" : m,
        pay: isPay ? m : "",
        balance: "",
      };
    });
  }, [salesreportinformation]);

  const reportTotals = useMemo(() => {
    let debt = 0;
    let pay = 0;
    for (const sale of salesreportinformation) {
      const m = parseFloat(sale.money || 0);
      if (isReportPaymentRow(sale)) pay += m;
      else debt += m;
    }
    const balance = debt - pay;
    return { debt, pay, balance };
  }, [salesreportinformation]);

  const downloadPdf = async () => {
    if (salesreportinformation.length === 0) {
      showToastMessage("error", "No data Found.");
      return;
    }

    const tableData = reportRowsWithSplits.map((sale) => ({
      ...sale,
      debt: sale.debt === "" ? "-" : "$" + parseFloat(sale.debt).toLocaleString("en-US"),
      pay: sale.pay === "" ? "-" : "$" + parseFloat(sale.pay).toLocaleString("en-US"),
      balance: "-",
    }));

    tableData.push({
      index: "-",
      customer_name: "-",
      customer_phone: "-",
      record_type: "Totals",
      data_source: "-",
      debt: "$" + reportTotals.debt.toLocaleString("en-US"),
      pay: "$" + reportTotals.pay.toLocaleString("en-US"),
      balance: "$" + reportTotals.balance.toLocaleString("en-US"),
      description: "-",
      fname: "-",
      date: "-",
    });

    const doc = new jsPDF({
      orientation: "landscape", // portrait | landscape
      unit: "mm",
      format: "a4",
    });
    const circularLogo = await createCircularImage(myImage);
    doc.addImage(circularLogo, "PNG", 118, 4, 40, 40);
    doc.text("CUSTOMER REPORT", 110, 50);
    autoTable(doc, {
      theme: "grid",
      columns: pdfColumns.map((col) => ({ ...col, dataKey: col.field })),
      body: tableData,
      startY: 65,
      margin: { top: 20, bottom: 20 },
      styles: {
        fontSize: 8,          // body font size
        cellPadding: 2,
        overflow: "linebreak",
      },
    });

    const currentdate = new Date();
    const documentName =
      "Customer_Report " +
      currentdate.getDate() +
      "/" +
      (currentdate.getMonth() + 1) +
      "/" +
      currentdate.getFullYear() +
      " : " +
      currentdate.getHours() +
      ":" +
      currentdate.getMinutes() +
      ":" +
      currentdate.getSeconds() +
      ".pdf";
    doc.save(documentName);
  };

  const tableClass =
    theme.palette.mode === "dark"
      ? "table table-striped table-dark"
      : "table table-striped";
  const emptyColor = theme.palette.mode === "dark" ? "black" : "white";
  const selectBgColor = theme.palette.mode === "light" ? "#E8F0FE" : "#323848";
  const selectFgColor = theme.palette.mode === "light" ? "black" : "white";
  return (
    <>
      <Modal show={show} onHide={handleClose} style={{ color: "black" }}>
        <Modal.Header closeButton>
          <Modal.Title>Cancel this Sell?</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to cancel this Sell?</Modal.Body>
        <Modal.Footer>
          <B variant="primary" onClick={handleClickDeleteButton}>
            Yes
          </B>
          <B variant="danger" onClick={handleClose}>
            No
          </B>
        </Modal.Footer>
      </Modal>
      <Box m="20px">
        <ToastContainer />
        <Header title="CUSTOMER REPORT" subtitle="" />

        <form id="regExpenseForm" onSubmit={handleFormSubmit}>
          <Box
            display="grid"
            gap="40px"
            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
            sx={{
              "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
            }}
          >
            <div className="row" style={{ width: "450%" }}>
              <div className="col-2 ">
                <select
                  onChange={handleOnChange}
                  fullWidth
                  variant="filled"
                  component="select"
                  name="customer_id"
                  id="customer_id"
                  style={{
                    backgroundColor: selectBgColor,
                    color: selectFgColor,
                    height: "100%",
                    width: "100%",
                  }}
                  required
                >
                  <option value="">Select Customer</option>
                  {customer_information.map((customer, index) => (
                    <option key={index} value={customer.customer_id}>
                      {customer.customer_name + " | " + customer.customer_phone}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-3 ">
                <TextField
                  fullWidth
                  variant="filled"
                  type="date"
                  label="From Date"
                  onChange={handleOnChange}
                  // value={values.RegisterDate}
                  name="fromDate"
                  // sx={{ gridColumn: "span 2" }}
                  required
                />
              </div>
              <div className="col-3 ">
                <TextField
                  fullWidth
                  variant="filled"
                  type="date"
                  label="To Date"
                  onChange={handleOnChange}
                  // value={values.RegisterDate}
                  name="toDate"
                  // sx={{ gridColumn: "span 2" }}
                  required
                />
              </div>
              <div className="col-2 ">
                <Button
                  type="submit"
                  color="secondary"
                  variant="contained"
                  style={{ height: "100%", width: "100%" }}
                  id="btnSubmit"
                >
                  Search
                </Button>
              </div>
              <div className="col-2 ">
                <Button
                  type="button"
                  color="info"
                  variant="contained"
                  style={{ height: "100%", width: "100%" }}
                  onClick={downloadPdf}
                >
                  <DownloadOutlinedIcon sx={{ mr: "10px" }} />
                  Download
                </Button>
              </div>
            </div>
          </Box>
        </form>

        {salesreportinformation.length === 0 ? (
          <h1
            style={{
              color: { emptyColor },
              textAlign: "center",
              marginTop: "8%",
            }}
          >
            No data Found
          </h1>
        ) : (
          <Table className={tableClass} style={{ marginTop: "3%" }}>
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col">Phone</th>
                <th scope="col">Type</th>
                <th scope="col">Data Source</th>
                <th scope="col">Debt</th>
                <th scope="col">Pay</th>
                <th scope="col">Balance</th>
                <th scope="col">Description</th>
                <th scope="col">Register By</th>
                <th scope="col">Date</th>
                {/* <th scope="col">Action</th> */}
              </tr>
            </thead>
            <tbody>
              {reportRowsWithSplits.map((sale, index) => {
                const d = sale.debt === "" ? "-" : `$${parseFloat(sale.debt).toLocaleString("en-US")}`;
                const p = sale.pay === "" ? "-" : `$${parseFloat(sale.pay).toLocaleString("en-US")}`;
                return (
                  <tr key={index}>
                    <td>{sale.index}</td>
                    <td>{sale.customer_name}</td>
                    <td>{sale.customer_phone}</td>
                    <td>{sale.record_type}</td>
                    <td>{sale.data_source}</td>
                    <td>{d}</td>
                    <td>{p}</td>
                    <td>-</td>
                    <td>{sale.description}</td>
                    <td>{sale.fname}</td>
                    <td>{sale.date}</td>
                   
                    {/* <td>
                      <B
                        type="button"
                        className="btn btn-danger btn-sm"
                        variant="contained"
                        onClick={() => handleClickDelete(sale.date)}
                      >
                        <AiFillCloseCircle style={{ color: "white" }} />
                      </B>{" "}
                    </td> */}
                  </tr>
                );
              })}
              <tr>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>Totals</td>
                <td>-</td>
                <td>${reportTotals.debt.toLocaleString("en-US")}</td>
                <td>${reportTotals.pay.toLocaleString("en-US")}</td>
                <td>${reportTotals.balance.toLocaleString("en-US")}</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </tr>
            </tbody>
          </Table>
        )}
      </Box>
    </>
  );
};

export default Form;
